import { notify, UploadDragger } from "components/common"
import { useMeetingVerificationMutation } from "features/tasks/api"

const MeetingVerificationAttachmentUploader = props => {
  const {
    setFiles,
    name,
    files,
    setField,
    fieldName,
    maxCount = 3,
    allowedFileSize = 5,
    imageType = "image/png, image/jpeg, image/jpg",
    disabled,
  } = props
  const [meetingVerification, { isLoading }] = useMeetingVerificationMutation()

  const onUpload = async ({ name, file }) => {
    try {
      const response = await meetingVerification({ name, file }).unwrap()
      notify.success(response?.message || "")
      setFiles(encodedFile => [...encodedFile, { name, file }])
    } catch (error) {
      notify.error(error?.message || "")
    }
  }

  return (
    <UploadDragger
      name={name}
      files={files}
      setFiles={setFiles}
      fieldName={fieldName}
      setField={setField}
      disabled={disabled}
      allowedFileSize={allowedFileSize}
      maxCount={maxCount}
      imageType={imageType}
      isLoading={isLoading}
      meetingValidationRequest={onUpload}
    />
  )
}
export default MeetingVerificationAttachmentUploader
